module.exports = __webpack_public_path__ + "media/banner.ba1820ff.mp4";